export default {
  anyMistakes:
    'Falls Informationen auf dieser Seite fehlerhaft erscheinen, dann einfach',
  contactUs: 'uns hier kontaktieren',
  social: 'Wir sind sozial | Folge uns',
}
